export default {
	data() {
		return {
			isLoading: false
		}
	},
	mounted() {
		this.$root.$on('set-loading', value => this.isLoading = value);
	}
}